/** Broadcast when a reset (or undo) rewrites `doc.variables` on attached docs. */
export const DOC_VARIABLES_UPDATED_EVENT = 'fokus:doc-variables-updated';

/**
 * Tell open editors + the library list that these docs have new variable rows.
 * `updates` is `[{ id, variables }]`.
 */
export function dispatchDocVariablesUpdated(updates) {
  const list = Array.isArray(updates) ? updates.filter((u) => u?.id) : [];
  if (list.length === 0) return;
  window.dispatchEvent(
    new CustomEvent(DOC_VARIABLES_UPDATED_EVENT, { detail: { updates: list } })
  );
  window.dispatchEvent(new CustomEvent('fokus:docs-changed'));
}

/** Subscribe to variable-row updates for one open doc. */
export function subscribeDocVariablesUpdated(docId, onVariables) {
  if (!docId || typeof onVariables !== 'function') return () => {};
  const handler = (event) => {
    const updates = event.detail?.updates;
    if (!Array.isArray(updates)) return;
    const hit = updates.find((u) => u.id === docId);
    if (!hit || !Array.isArray(hit.variables)) return;
    onVariables(hit.variables);
  };
  window.addEventListener(DOC_VARIABLES_UPDATED_EVENT, handler);
  return () => window.removeEventListener(DOC_VARIABLES_UPDATED_EVENT, handler);
}
